import { DeepPartial } from "../../interfaces/deepPartial";
import {
  CalculationModel,
  Coverage,
  DlpState,
  InsuredPerson,
  InsuredPersonBase,
  PremiumTerms,
  SaveDlpStateRequest,
} from "./DlpFlow.interfaces";

const convertToInsuredPerson = ({
  firstName,
  dateOfBirth,
  isDefault,
  personId,
  isSmoking,
}: Partial<InsuredPerson>): Partial<InsuredPersonBase> => ({
  firstName,
  dateOfBirth,
  isDefault,
  personId,
  isSmoking,
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const convertCoverage = ({ hasDuration, hasEffectiveDate, hasInsuredAmount, ...coverage }: Partial<Coverage>) =>
  coverage;

export const convertDlpStateToCalculationModel = ({
  insuredPersons,
  coverages,
  paymentTerm,
}: DlpState): DeepPartial<CalculationModel> => ({
  insuredPersons: insuredPersons.map(convertToInsuredPerson),
  coverages: coverages.map(convertCoverage),
  paymentTerm,
});

export const convertDlpStateToSaveDlpStateRequest = (
  data: DlpState,
  premium: PremiumTerms | null,
  applicationId: string | null
): SaveDlpStateRequest => ({
  applicationId,
  firstName: data.insuredPersons[0].firstName,
  lastName: data.insuredPersons[0].lastName,
  inserts: data.insuredPersons[0].inserts,
  JSON: JSON.stringify({ ...data, premium }),
});
